export const CHANGE_SUSPENSION_FORM = "CHANGE_SUSPENSION_FORM";
export const UPDATE_FORM_ERRORS = "UPDATE_FORM_ERRORS";